import { SET_UTM_TERM_SOURCE_TYPE } from 'actions';

export const setUtmTermSourceType = (utmTerm: string) => {
  return { type: SET_UTM_TERM_SOURCE_TYPE, utmTerm };
};
